import { render, staticRenderFns } from "./IdentifyCardUpload.vue?vue&type=template&id=249178be&scoped=true"
import script from "./IdentifyCardUpload.vue?vue&type=script&lang=js"
export * from "./IdentifyCardUpload.vue?vue&type=script&lang=js"
import style0 from "./IdentifyCardUpload.vue?vue&type=style&index=0&id=249178be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249178be",
  null
  
)

export default component.exports